import React, { useState, useCallback, useEffect } from 'react';
import { usePromoPresentation } from '../../contexts/PromoPresentationProvider';
import { PromoHeader } from '../promo-header/PromoHeader';
import { PromoList } from '../promo-list/PromoList';
import { PromoSidecar } from '../promo-sidecar/PromoSidecar';
import './PromoDrawer.scss';

export const PromoDrawer = () => {
  const {
    isDrawerOpen,
    setIsDrawerOpen,
    setIsFirstProductPodVisible
  } = usePromoPresentation();
  const [promoHeaderHeight, setPromoHeaderHeight] = useState(0);

  useEffect(() => {
    if (!isDrawerOpen) document.body.classList.remove('thd-overlay__body--behind-mobile');
  }, [isDrawerOpen]);

  const hideHeader = useCallback(() => {
    const firstProductPod = document.querySelectorAll('.promo-drawer--open .promo-pod')[0];
    if (firstProductPod) {
      if (!promoHeaderHeight) {
        setPromoHeaderHeight(document.querySelector('.promo-drawer--open .promo-header')
          .getBoundingClientRect().height);
      }
      const firstProductRect = firstProductPod.getBoundingClientRect();
      setIsFirstProductPodVisible(firstProductRect.top >= (promoHeaderHeight - firstProductRect.height));
    }
  }, [promoHeaderHeight, setPromoHeaderHeight, setIsFirstProductPodVisible]);

  return (
    <PromoSidecar useSidecarMask isSidecarOpen={isDrawerOpen} setIsSidecarOpen={setIsDrawerOpen}>
      <article
        className="promo-drawer"
        data-testid={`${isDrawerOpen ? 'promo-drawer--open' : 'promo-drawer--closed'}`}
        onScroll={hideHeader}
      >
        <PromoHeader />
        <PromoList />
      </article>
    </PromoSidecar>
  );
};

PromoDrawer.displayName = 'PromoDrawer';
